import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Users, Briefcase, FileText, CreditCard } from 'lucide-react';
import { AdminAuthProvider } from './context/AdminAuthContext';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminPlaceholderPage from './pages/AdminPlaceholderPage';
import './admin.css';

const AdminApp = () => {
  useEffect(() => {
    document.title = 'isBulsun Admin';
  }, []);

  return (
    <AdminAuthProvider>
      <Router>
        <div className="admin-root">
          <Routes>
            <Route path="/" element={<AdminLoginPage />} />
            <Route
              path="/panel"
              element={
                <AdminProtectedRoute>
                  <AdminDashboardPage />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/panel/adaylar"
              element={
                <AdminProtectedRoute>
                  <AdminPlaceholderPage
                    title="Adaylar"
                    icon={Users}
                    description="Aday listesi ve profil detayları için backend admin API'si hazır olduğunda burası dolacak."
                  />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/panel/ilanlar"
              element={
                <AdminProtectedRoute>
                  <AdminPlaceholderPage
                    title="İlanlar"
                    icon={Briefcase}
                    description="İş ilanı yönetimi (oluşturma, düzenleme, yayından kaldırma) burada olacak."
                  />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/panel/basvurular"
              element={
                <AdminProtectedRoute>
                  <AdminPlaceholderPage
                    title="Başvurular"
                    icon={FileText}
                    description="Adayların ilanlara yaptığı başvurular ve durumları burada listelenecek."
                  />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/panel/abonelikler"
              element={
                <AdminProtectedRoute>
                  <AdminPlaceholderPage
                    title="Abonelikler"
                    icon={CreditCard}
                    description="AutoApply ve TransMeet abonelikleri, ödeme durumları burada yönetilecek."
                  />
                </AdminProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AdminAuthProvider>
  );
};

export default AdminApp;
